import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ChatMessageListItem } from 'src/@types/chat';
import { ChatRequests } from 'src/requests/chat';
import { useChatConversationContext } from 'src/sections/@dashboard/chat/ChatConversation/useChatConversationContext';
import { useUpdateMessage } from 'src/sections/@dashboard/chat/ChatConversation/useUpdateMessage';

type Props = {
  channelId: string;
};

export const useEditMessage = ({ channelId }: Props) => {
  const { goToMessage } = useChatConversationContext();
  const { updateMessage } = useUpdateMessage({ channelId, goToMessage });

  const queryClient = useQueryClient();

  const queryKey = ['channels', channelId, goToMessage];

  const { mutateAsync: editMessage, isLoading: isEditingMessage } = useMutation(
    {
      mutationFn: ChatRequests.editMessage,
      async onMutate(updatedMessage) {
        await queryClient.cancelQueries({ queryKey });

        // Snapshot the previous value
        const previousTodos = queryClient.getQueryData(queryKey);

        updateMessage({
          _id: updatedMessage.id,
          channel: updatedMessage.channel,
          content: updatedMessage.content,
          edited: true,
        } as ChatMessageListItem);

        return { previousTodos };
      },
      onError(err, newTodo, context) {
        queryClient.setQueryData(queryKey, context?.previousTodos);
      },
      onSettled() {
        queryClient.invalidateQueries({ queryKey });
      },
    },
  );

  return {
    editMessage,
    isEditingMessage,
  };
};
